// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var TextLines = require("./TextLines.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MuiDemoUtils = require("./MuiDemoUtils.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/Expln_React_Row.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var Clear = require("@mui/icons-material/Clear").default;
var InputAdornment = require("@mui/material/InputAdornment").default;

function textToElems(t) {
  return TextLines.tlMap(t, (function (idx, i, s) {
                return React.createElement("div", {
                            key: String(idx) + s,
                            style: {
                              paddingLeft: String(Math.imul(i, 10)) + "px"
                            }
                          }, s);
              }));
}

function rndAttr(name, value, renderValue) {
  if (value !== undefined) {
    return TextLines.tlFromStrings(["" + name + "=" + Curry._1(renderValue, Caml_option.valFromOption(value)) + ""]);
  } else {
    return TextLines.tlFromStrings([]);
  }
}

function rndStrAttr(name, value) {
  return rndAttr(name, value, (function (str) {
                return "\"" + str + "\"";
              }));
}

function rndIntAttr(name, value) {
  return rndAttr(name, value, (function (i) {
                return String(i);
              }));
}

function rndBoolAttr(name, value) {
  return rndAttr(name, value, (function (b) {
                if (b) {
                  return "true";
                } else {
                  return "false";
                }
              }));
}

function TextFieldDemo(Props) {
  var match = React.useState(function () {
        
      });
  var setValue = match[1];
  var value = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setLabel = match$1[1];
  var label = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setSize = match$2[1];
  var size = match$2[0];
  var sizePossibleValues = [
    [
      "medium",
      "medium",
      "#medium"
    ],
    [
      "small",
      "small",
      "#small"
    ]
  ];
  var match$3 = React.useState(function () {
        
      });
  var setVariant = match$3[1];
  var variant = match$3[0];
  var variantPossibleValues = [
    [
      "filled",
      "filled",
      "#filled"
    ],
    [
      "outlined",
      "outlined",
      "#outlined"
    ],
    [
      "standard",
      "standard",
      "#standard"
    ]
  ];
  var match$4 = React.useState(function () {
        
      });
  var setAdornment = match$4[1];
  var adornment = match$4[0];
  var adornmentPossibleValues = [
    [
      "start",
      "start",
      "#start"
    ],
    [
      "end",
      "end",
      "#end"
    ]
  ];
  var match$5 = React.useState(function () {
        
      });
  var setMultiline = match$5[1];
  var multiline = match$5[0];
  var match$6 = React.useState(function () {
        
      });
  var setMinRows = match$6[1];
  var minRows = match$6[0];
  var match$7 = React.useState(function () {
        
      });
  var setMaxRows = match$7[1];
  var maxRows = match$7[0];
  var match$8 = React.useState(function () {
        
      });
  var setCols = match$8[1];
  var cols = match$8[0];
  var match$9 = React.useState(function () {
        
      });
  var setDisabled = match$9[1];
  var disabled = match$9[0];
  var rndTextField = function (param) {
    var tmp = {
      value: MuiDemoUtils.strOrNull(value),
      label: MuiDemoUtils.strOrNull(label),
      onChange: (function (param) {
          return Expln_React_common.evt2str((function (str) {
                        Curry._1(setValue, (function (param) {
                                return str;
                              }));
                      }), param);
        })
    };
    if (size !== undefined) {
      tmp.size = Caml_option.valFromOption(size);
    }
    if (variant !== undefined) {
      tmp.variant = Caml_option.valFromOption(variant);
    }
    if (multiline !== undefined) {
      tmp.multiline = multiline;
    }
    if (minRows !== undefined) {
      tmp.minRows = minRows;
    }
    if (maxRows !== undefined) {
      tmp.maxRows = maxRows;
    }
    if (disabled !== undefined) {
      tmp.disabled = disabled;
    }
    var res = React.createElement(TextField, tmp);
    var res$1;
    if (adornment !== undefined) {
      var inputAdornment = React.createElement(InputAdornment, {
            position: adornment,
            children: React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(setValue, (function (param) {
                              return "";
                            }));
                    }),
                  children: React.createElement(Clear, {})
                })
          });
      res$1 = React.cloneElement(res, {
            InputProps: adornment === "start" ? ({
                  startAdornment: inputAdornment,
                  endAdornment: null
                }) : ({
                  startAdornment: null,
                  endAdornment: inputAdornment
                })
          });
    } else {
      res$1 = res;
    }
    if (cols !== undefined) {
      return React.cloneElement(res$1, {
                  inputProps: {
                    cols: cols
                  }
                });
    } else {
      return res$1;
    }
  };
  var rndAdornment = function (param) {
    if (adornment === undefined) {
      return TextLines.tlFromStrings([""]);
    }
    var attrName = adornment === "start" ? "startAdornment" : "endAdornment";
    return TextLines.tlConcatAll([
                TextLines.tlFromStrings(["\"InputProps\": {"]),
                TextLines.tlShift(TextLines.tlFromStrings(["\"" + attrName + "\": {"]), 4),
                TextLines.tlShift(TextLines.tlFromStrings(["<InputAdornment position=#" + MuiDemoUtils.valToStr(undefined, adornmentPossibleValues, adornment) + ">"]), 8),
                TextLines.tlShift(TextLines.tlFromStrings(["<IconButton onClick={_ => setValue(Some(\"\"))}>"]), 12),
                TextLines.tlShift(TextLines.tlFromStrings(["<Icons.Clear/>"]), 16),
                TextLines.tlShift(TextLines.tlFromStrings(["</IconButton>"]), 12),
                TextLines.tlShift(TextLines.tlFromStrings(["</InputAdornment>"]), 8),
                TextLines.tlShift(TextLines.tlFromStrings(["}"]), 4),
                TextLines.tlFromStrings(["}"])
              ]);
  };
  var rndTextFieldCode = function (param) {
    var simpleAttrs = TextLines.tlShift(TextLines.tlConcatAll([
              rndStrAttr("value", value),
              rndStrAttr("label", label),
              rndAttr("size", size, (function (v) {
                      return MuiDemoUtils.valToCode(undefined, sizePossibleValues, v);
                    })),
              rndAttr("variant", variant, (function (v) {
                      return MuiDemoUtils.valToCode(undefined, variantPossibleValues, v);
                    })),
              rndBoolAttr("multiline", multiline),
              rndIntAttr("minRows", minRows),
              rndIntAttr("maxRows", maxRows),
              rndBoolAttr("disabled", disabled)
            ]), 4);
    var res = TextLines.tlConcatAll([
          TextLines.tlFromStrings(["<TextField"]),
          simpleAttrs,
          TextLines.tlFromStrings(["/>"])
        ]);
    var res$1;
    if (Belt_Option.isSome(adornment) || Belt_Option.isSome(cols)) {
      var res$2 = TextLines.tlConcatAll([
            TextLines.tlFromStrings(["let textField = "]),
            TextLines.tlShift(res, 4)
          ]);
      var res$3 = adornment !== undefined ? TextLines.tlConcatAll([
              res$2,
              TextLines.tlFromStrings(["let textField = React.cloneElement(textField, {"]),
              TextLines.tlShift(rndAdornment(undefined), 4),
              TextLines.tlFromStrings(["})"])
            ]) : res$2;
      var res$4 = cols !== undefined ? TextLines.tlConcatAll([
              res$3,
              TextLines.tlFromStrings(["let textField = React.cloneElement(textField, {"]),
              TextLines.tlShift(TextLines.tlFromStrings(["\"inputProps\": {\"cols\": " + String(cols) + "}"]), 4),
              TextLines.tlFromStrings(["})"])
            ]) : res$3;
      res$1 = TextLines.tlConcatAll([
            res$4,
            TextLines.tlFromStrings(["textField"])
          ]);
    } else {
      res$1 = res;
    }
    return React.createElement("div", {
                style: {
                  padding: "20px"
                }
              }, textToElems(res$1));
  };
  return React.createElement(Expln_React_Column.make, {
              justifyContent: "flex-start",
              spacing: 2,
              style: {
                padding: "10px"
              },
              children: null
            }, React.createElement(Expln_React_Row.make, {
                  spacing: 1,
                  children: null
                }, React.createElement(Paper, {
                      style: {
                        padding: "50px"
                      },
                      children: rndTextField(undefined)
                    }), React.createElement(Paper, {
                      children: rndTextFieldCode(undefined)
                    })), MuiDemoUtils.rndStringParam("value", "value", value, (function (v) {
                    Curry._1(setValue, (function (param) {
                            return v;
                          }));
                  })), MuiDemoUtils.rndStringParam("label", "label", label, (function (v) {
                    Curry._1(setLabel, (function (param) {
                            return v;
                          }));
                  })), MuiDemoUtils.rndEnumParam("size", "medium", size, (function (v) {
                    Curry._1(setSize, (function (param) {
                            return v;
                          }));
                  }), sizePossibleValues), MuiDemoUtils.rndEnumParam("variant", "outlined", variant, (function (v) {
                    Curry._1(setVariant, (function (param) {
                            return v;
                          }));
                  }), variantPossibleValues), MuiDemoUtils.rndEnumParam("adornment", "end", adornment, (function (v) {
                    Curry._1(setAdornment, (function (param) {
                            return v;
                          }));
                  }), adornmentPossibleValues), MuiDemoUtils.rndBoolParam("multiline", true, multiline, (function (v) {
                    Curry._1(setMultiline, (function (param) {
                            return v;
                          }));
                  })), MuiDemoUtils.rndIntSliderParam("minRows", 1, minRows, (function (v) {
                    Curry._1(setMinRows, (function (param) {
                            return v;
                          }));
                  }), 1, 10, 1), MuiDemoUtils.rndIntSliderParam("maxRows", 1, maxRows, (function (v) {
                    Curry._1(setMaxRows, (function (param) {
                            return v;
                          }));
                  }), 1, 20, 1), MuiDemoUtils.rndIntSliderParam("cols", 20, cols, (function (v) {
                    Curry._1(setCols, (function (param) {
                            return v;
                          }));
                  }), 5, 50, 1), MuiDemoUtils.rndBoolParam("disabled", true, disabled, (function (v) {
                    Curry._1(setDisabled, (function (param) {
                            return v;
                          }));
                  })));
}

var codeTabWidth = 4;

var make = TextFieldDemo;

exports.codeTabWidth = codeTabWidth;
exports.textToElems = textToElems;
exports.rndAttr = rndAttr;
exports.rndStrAttr = rndStrAttr;
exports.rndIntAttr = rndIntAttr;
exports.rndBoolAttr = rndBoolAttr;
exports.make = make;
/* react Not a pure module */
